export class MultiProgress {
    #progresses: { percent: number; weight: number }[] = [];

    get percent(): number | undefined {
        if (!this.#progresses.length) {
            return undefined;
        }

        let totalProgress = 0;

        this.#progresses.forEach((progress) => {
            totalProgress += progress.weight;
        });

        let currentProgress = 0;

        this.#progresses.forEach((progress) => {
            currentProgress += progress.percent * progress.weight;
        });

        return Math.trunc(currentProgress / totalProgress);
    }

    reset() {
        this.#progresses = [];
    }

    init = (index: number, weight: number) => {
        this.#progresses[index] = { percent: 0, weight: weight };
    };

    update = (index: number, percent: number) => {
        this.#progresses[index].percent = percent;
    };
}
